module.exports = __webpack_public_path__ + "static/xile-ff628c8fdba33d56d51ff1ffad30b9f4.png";